import { useSearchParams } from 'react-router-dom';
import CreditTransactionsList from '../components/CreditTransactionsList';
import CustomerCreditBalances from '../components/CustomerCreditBalances';

const TABS = [
  { key: 'transactions', label: 'Transactions' },
  { key: 'balances', label: 'Customer Balances' }
] as const;

type TabKey = (typeof TABS)[number]['key'];

const CreditTransactions = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get('tab');
  const activeTab: TabKey = tabParam === 'balances' ? 'balances' : 'transactions';

  const parsedPage = parseInt(searchParams.get('page') || '1', 10);
  const currentPage = isNaN(parsedPage) || parsedPage < 1 ? 1 : parsedPage;

  const handleTabChange = (tab: TabKey) => {
    setSearchParams(prev => {
      prev.set('tab', tab);
      prev.set('page', '1');
      return prev;
    });
  };

  const handlePageChange = (page: number) => {
    setSearchParams(prev => { prev.set('page', String(page)); return prev; });
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Credit Transactions</h1>
        <p className="text-gray-600">Browse all customer credit transactions</p>
      </div>

      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-6" aria-label="Credit views">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => handleTabChange(tab.key)}
              aria-current={activeTab === tab.key ? 'page' : undefined}
              className={`whitespace-nowrap border-b-2 py-3 px-1 text-sm font-medium ${
                activeTab === tab.key
                  ? 'border-black text-gray-900'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {activeTab === 'balances' ? (
        <CustomerCreditBalances page={currentPage} onPageChange={handlePageChange} />
      ) : (
        <CreditTransactionsList page={currentPage} onPageChange={handlePageChange} />
      )}
    </div>
  );
};

export default CreditTransactions;
